export default __webpack_public_path__ + "static/media/loupe_diary.d03e1f9d.svg";